import * as React from "react";

export interface TeamDetailItemProps {
  src: string;
  name: string;
  title: string;
  text: string;
  alignRight?: boolean;
}

// TODO: Probably a nicer way to do this
const TeamDetailItem = (props: TeamDetailItemProps) => (
  <div className="col-md-6">
    <div className="team-details">
      <img src={props.src} className="img-responsive" />
      <h2 className="text-center">{props.name}</h2>
      <h3 className="text-center">{props.title}</h3>
      <p className="text-justify">{props.text}</p>
    </div>
  </div>
);

export default TeamDetailItem;



// WEBPACK FOOTER //
// ./src/routes/Team/components/TeamDetailItem.tsx